import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b41ba8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lbl-title" }, "Sales Notes are deleted!!!")
], -1 /* HOISTED */))
const _hoisted_4 = {
  key: 1,
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "main-div" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lbl-title" }, "Do You Cancel Sales Notes?")
], -1 /* HOISTED */))
const _hoisted_8 = {
  id: "tbldiv",
  class: "tbl-div"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"tblTitle-div\" style=\"width:calc(100% - 16px);\" data-v-1b41ba8e><table id=\"tblIssueSalesNote\" class=\"w-100\" data-v-1b41ba8e><tr data-v-1b41ba8e><th style=\"width:10%;\" data-v-1b41ba8e>Sales No.</th><th style=\"width:16%;\" data-v-1b41ba8e>Production Month</th><th style=\"width:10%;\" data-v-1b41ba8e>Factory</th><th style=\"width:20%;\" data-v-1b41ba8e>Status</th><th style=\"width:12%;\" data-v-1b41ba8e>Date of Issue</th><th style=\"width:14%;\" data-v-1b41ba8e>Date of Approval</th><th style=\"width:18%;\" data-v-1b41ba8e>Date of Agreement</th></tr></table></div>", 1)
const _hoisted_10 = {
  id: "tblbodydiv",
  class: "tblbody-div"
}
const _hoisted_11 = {
  id: "tblIssueSalesNoteDetail",
  class: "w-100"
}
const _hoisted_12 = { id: "tbltbody" }
const _hoisted_13 = { style: {"width":"10%"} }
const _hoisted_14 = { style: {"width":"16%"} }
const _hoisted_15 = { style: {"width":"10%"} }
const _hoisted_16 = { style: {"width":"20%"} }
const _hoisted_17 = { style: {"width":"12%"} }
const _hoisted_18 = { style: {"width":"14%"} }
const _hoisted_19 = { style: {"width":"28%"} }
const _hoisted_20 = { class: "btn-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.btnFlag == true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["Navigation"]),
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
        _createVNode($setup["SalesNoteHeaderNavigation"]),
        _createVNode($setup["SalesNoteLinkNavigation"]),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-exit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.btnExit()))
          }, " EXIT ")
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode($setup["Navigation"]),
        ($setup.isLoadingcheck == 'true')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"])
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
        _createVNode($setup["SalesNoteHeaderNavigation"]),
        _createVNode($setup["SalesNoteLinkNavigation"]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _createElementVNode("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paramSalesNote, (info, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(info.salesNo), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(info.prodYM), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(info.factory), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(info.statusDescription), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(info.issueDate), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(info.smcApproveDate), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(info.distributorApproveDate), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.btnClick('NO')))
            }, "NO"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-circulation",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.btnClick('YES')))
            }, "YES")
          ])
        ])
      ]))
}